import { useForm } from "react-hook-form";
import { Form, FormItem, FormRow, FormError } from "@/components/form";
import { Flex } from "@/components/flex";
import { Button } from "@/components/button";
import { Loader } from "@/components/loader";
import { ILocation } from "@/models/types";
import { useAppDispatch, useAppSelector } from "src/config/store";
import { validationSchema } from "src/utils/validation-utils";
import { createLocation, editLocation } from "@/reducers/location-crud.reducer";
import ModalBody from "@/components/modal/modal-body";
import ModalHeader from "@/components/modal/modal-header";

type Props = {
  location: ILocation;
};

const LocationsEdit = (props: Props) => {
  const { location } = props;

  const isEdit = location.ID ? true : false;
  const dispatch = useAppDispatch();
  const locationsCrudState = useAppSelector((state) => state.locationsCrud);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({ mode: "onChange", defaultValues: location });

  const save = (data) => {
    isEdit ? dispatch(editLocation(data)) : dispatch(createLocation(data));
  };

  return (
    <>
      <ModalHeader />
      <ModalBody>
        <Form>
          <FormRow>
            <FormItem name="post_title" label={"Nome"}>
              <input
                id="post_title"
                placeholder={"Nome"}
                {...register("post_title", validationSchema.required)}
              />

              {errors.post_title && <FormError error={errors.post_title.message} />}
            </FormItem>
          </FormRow>

          <FormRow>
            <FormItem name="city" label={"Città"}>
              <input id="city" placeholder={"Città"} {...register("city", validationSchema.required)} />

              {errors.city && <FormError error={errors.city.message} />}
            </FormItem>
          </FormRow>

          <FormRow>
            <FormItem>
              <Flex container alignItems="center">
                <Button
                  className="ml-auto"
                  size="md"
                  color="primary"
                  disabled={!isValid || locationsCrudState.loading}
                  onClick={handleSubmit(save)}
                >
                  {locationsCrudState.loading ? <Loader /> : "Salva"}
                </Button>
              </Flex>
            </FormItem>
          </FormRow>
        </Form>
      </ModalBody>
    </>
  );
};

export default LocationsEdit;
